<template>
	<div class="vlog-home">
		<div class="py-4 search-bar">
			<form role="form" class="relative flex z-50 bg-gray-100  rounded-full">
				<input
					v-model="searchTerm"
					type="search"
					id="search-videos"
					placeholder="搜索视频"
					class="text-sm rounded-full flex-1 px-6 py-2 bg-gray-100 text-gray-700 focus:outline-none"
				/>

				<button
					type="submit"
					@click.prevent="handleSearch"
					class="text-sm bg-indigo-500 text-white rounded-full font-semibold px-4 py-1.5 m-1 focus:outline-none"
				>
					搜索
				</button>
			</form>
		</div>

		<div
			class="tab-content-container w-full"
			v-if="this.tabContentList?.length > 0"
		>
			<vlog-header-tab
				:tabList="tabList"
				:tabID="currentTabID"
				@changeSelectedTabID="changeSelectedTabIDCallback"
			></vlog-header-tab>
			<!-- 如果tabid不合法，则不显示 -->
			<div
				class="content-list-container mt-4 w-full "
				v-if="currentTabID.length > 0"
			>
				<keep-alive>
					<vlog-recommand-list v-if="currentTabID == 'recommand'">
					</vlog-recommand-list>
				</keep-alive>

				<template
					v-for="tabContent in this.tabContentList.slice(1)"
					:key="tabContent.id"
				>
					<keep-alive>
						<vlog-content-list
							v-if="currentTabID == tabContent.id"
							:contentType="tabContent.data.contentType"
							:type="tabContent.data.type"
							:categoryID="tabContent.data.categoryAPIValue"
						>
						</vlog-content-list>
					</keep-alive>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import VlogHeaderTab from "@/components/vlog/components/HeaderTab.vue";
import VlogContentList from "@/components/vlog/contentList/VlogContentList.vue";
import VlogRecommandList from "@/components/vlog/contentList/VlogRecommandList.vue";
import axios from "axios";
import { useHead, useSeoMeta } from "@vueuse/head";

export default {
	name: "Vlog",
	components: {
		VlogHeaderTab,
		VlogContentList,
		VlogRecommandList,
	},
	props: {},
	data() {
		return {
			loading: false,
			loadingError: {},
			currentTabID: "",
			listComponents: {},
			tabContentList: [],
			tabList: [],
			tabInfoMap: {}, // id->名字、简介等信息
			searchTerm: "",
			// url中传入的id，如果匹配不到，则使用首页
			urlTabID: "",
			currentTabInfo: {},
			shareInfo: {},
		};
	},
	watch: {
		urlTabID(newVal, oldVal) {
			if (newVal != oldVal) {
				this.updateSelectedCategoryByURLParameter();
			}
		},
		currentTabID(newVal) {
			if (newVal) {
				this.currentTabInfo = this.tabInfoMap[newVal];
			} else {
				this.currentTabInfo = null;
			}
		},
		currentTabInfo() {
			this.updateMeta();
		},
	},
	methods: {
		updateMeta() {
			const websiteBasicInfo = this.$store.state.websiteBasicInfo;
			// console.log("websiteBasicInfo");
			// console.log(websiteBasicInfo);

			var shareTitle = this.currentTabInfo.name ? this.currentTabInfo.name : "视频官网";
			var seoTitle = shareTitle;
			var shareAbstract = "";

			if (websiteBasicInfo) {
				seoTitle = websiteBasicInfo.vlogDisplayTitle;
				shareAbstract = websiteBasicInfo.vlogDisplayTitle + " - " + websiteBasicInfo.domain;

				if (this.currentTabInfo.name) {
					seoTitle =
					this.currentTabInfo.name +
						" - " +
						websiteBasicInfo.vlogDisplayTitle;
				} else {
					seoTitle = websiteBasicInfo.vlogDisplayTitle;
				}
			}
			useHead({
				title: seoTitle,
				meta: [
					{
						name: "title",
						content: seoTitle,
					},
					{
						name: "description",
						content: websiteBasicInfo.description,
					},
					{
						name: "keywords",
						content: websiteBasicInfo.keywords,
					},
				],
			});
			useSeoMeta({
				description: shareAbstract,
				ogDescription: shareAbstract,
				ogTitle: shareTitle,
				ogImage: websiteBasicInfo.logoUrl,
			});

			// console.log(websiteBasicInfo);

			this.shareInfo = {
				description: shareAbstract,
				title: shareTitle,
				image: websiteBasicInfo.logoUrl,
				url: document.location.href,
			};

			this.$emitter.emit("didUpdateHeadMeta", this.shareInfo);
		},
		// todo: 监听urlCategoryID来获取数据中的tabid 触发headertab。
		// 因为这里tab id可能是多个id组成，所以不能直接匹配。
		// todo 更新url链接：这里考虑直接使用某一层单个cat id。不考虑第三级

		changeSelectedTabIDCallback(currentTabID) {
			this.switchToTabID(currentTabID);
		},
		switchToTabID(toTabID) {
			this.currentTabID = toTabID;
			// console.log("switched to tab id: ", currentTabID);
			// replace url
			var toPath = "";
			if (this.currentTabID == "recommand" || this.currentTabID?.length == 0) {
				toPath = "/vlog";
			} else {
				toPath = "/vlog/t/" + this.currentTabID;
			}
			// toPath;
			// console.log(toPath);
			this.$router.replace({ path: toPath, query: this.$route.query });
		},
		setupCategoryContent(tabList) {
			// setup tabContentList
			var list = [];
			var tabMap = {};
			// 除重
			var addedIDs = new Set();

			tabList.forEach(function(x) {
				if (!addedIDs.has(x.id)) {
					list.push({
						id: x.id,
						data: x,
					});
					if (x.id) {
						tabMap[x.id] = x;
					}
					addedIDs.add(x.id);
				}
				// x.subTabs?.forEach(function(y) {
				x.subList?.forEach(function(y) {
					if (!addedIDs.has(y.id)) {
						list.push({
							id: y.id,
							data: y,
						});
						if (y.id) {
							tabMap[y.id] = y;
						}
						addedIDs.add(y.id);
					}
				});
			});

			this.tabContentList = list;
			this.tabInfoMap = tabMap;
			// console.log(this.tabContentList);
		},
		prepareCategoryTab(categoryData) {
			// console.log(categoryData);
			// setup tab using
			// replace router path if needed

			// 最多两级
			var tabList = [];

			// 塞入推荐
			tabList.push({
				name: "推荐视频",
				id: "recommand",
				contentType: "recommand",
				categoryID: "0",
				categoryAPIValue: "",
				// 保存没有item但是需要保存在这个item里的cate id。目前就是三级的。如果下一级已经有对应item，不放在这里。这样匹配的某个特定id时候就可以匹配到
				subCategoryIDs: [],
				subTabIDs: [],
			});

			// 第一级
			categoryData.forEach(function(x) {
				var item = {
					name: x.name,
					id: "c2_" + x.id,
					contentType: "content",
					type: "2",
					categoryID: "" + x.id,
					categoryAPIValue: "" + x.id,
				};

				// 第二级
				// 如果第一级包含children > 0，则第二级第一个为「全部」，cate id需要额外包含所有二级id和三级id
				// 如果有第三级、需要将cat id并到第二级中。否则接口无法获取到。
				// todo： 全部里面没有包含三级id
				if (x.children?.length > 0) {
					var subtabs = [];

					x.children.forEach(function(y) {
						var subItem = {
							name: y.name,
							contentType: "content",
							type: "2",
						};

						var cateAPIValue = "" + y.id + ",";
						// 添加所有三级的id
						cateAPIValue += y.children?.reduce(function(acc, cur) {
							return acc + cur.id + ",";
						}, "");
						cateAPIValue = cateAPIValue.replace(/[ ,]+$/, "");
						subItem.categoryAPIValue = cateAPIValue;

						// 获取三级的子cate id
						var subCateIDs = [];
						y.children?.reduce(function(acc, cur) {
							return subCateIDs.push("" + cur.id);
						}, subCateIDs);
						//
						subItem.subCategoryIDs = subCateIDs;

						var subTabIDs = [];
						y.children?.reduce(function(acc, cur) {
							return subTabIDs.push("c2_" + cur.id);
						}, subTabIDs);
						subItem.subTabIDs = subTabIDs;

						//
						// 更换为实际的二级id作为categoryID，三级的只保存数据作参考
						// subItem.categoryID = cateAPIValue;
						subItem.categoryID = y.id;

						subItem.id = "c2_" + subItem.categoryID;

						subtabs.push(subItem);
					});

					// 如果包含二级栏目，这里会添加一个api值包含所有二级栏目和一级栏目本身cate id的「所有」tab。
					// 这个tab的id本身可以使用一级栏目的category id。subcategory可以为空，因为如果其他二级栏目，会匹配到那个二级栏目。

					var defaultItem = {
						name: "全部",
						contentType: "content",
						type: "2",
					};

					// defaultItem.categoryID = "" + x.id + ",";
					// // 添加所有其他二级的id
					// defaultItem.categoryID += x.children?.reduce(function(acc, cur) {
					// 	return acc + "," + cur.id;
					// }, "");
					// defaultItem.categoryID = defaultItem.categoryID.trim(",");

					var cateAPIValue = "" + x.id + ",";
					// 添加其他所有二级的id和三级的id
					cateAPIValue += subtabs?.reduce(function(acc, cur) {
						return acc + cur.categoryAPIValue + ",";
					}, "");
					cateAPIValue = cateAPIValue.replace(/[ ,]+$/, "");

					defaultItem.categoryAPIValue = cateAPIValue;
					defaultItem.categoryID = "" + x.id;
					defaultItem.subCategoryIDs = [];
					defaultItem.subTabIDs = [];
					defaultItem.id = "c2_" + defaultItem.categoryID;

					// insert to first
					subtabs = [defaultItem].concat(subtabs);

					item.subList = subtabs;
				}

				tabList.push(item);
				// console.log("---tablist---");
				// console.log(tabList);
			});
			return tabList;
		},
		setupCategoryTabs(responseData) {
			this.tabList = this.prepareCategoryTab(responseData);
			// console.log(this.tabList);
			this.setupCategoryContent(this.tabList);
			// update selected tab if needed.
			this.updateSelectedCategoryByURLParameter();
		},
		matchedTabIDWithTabID(tabID) {
			var matchedTabID = "";
			// console.log("prepare to match: " + tabID);

			if (tabID?.length > 0) {
				this.tabList?.forEach(function(x) {
					if (x.id == tabID) {
						// console.log("found x.id: " + tabID);
						matchedTabID = tabID;
					}
					// 遍历二级
					x.subList?.forEach(function(y) {
						// console.log("will match children");
						// console.log(x.children);

						if (tabID == y.id) {
							// console.log("found y.id: " + tabID);

							matchedTabID = y.id;
						}
						// 匹配到下一级的元素，就是用当前这个
						else if (y.subTabIDs?.includes(tabID)) {
							matchedTabID = y.id;
						}
					});
				});
			}

			// console.log(matchedTabID);
			return matchedTabID;
		},
		updateSelectedCategoryByURLParameter() {
			// 1. 检查url传入的categoryid是否在数据中存在
			// console.log(this.urlTabID);

			var tabID = this.matchedTabIDWithTabID(this.urlTabID);
			// console.log(tabID);

			// 2. 如果存在，切换到该category
			if (tabID?.length > 0) {
				this.switchToTabID(tabID);
			}
			// 2.1 如果这个category是一个三级category，那就选中其所属的二级分类
			// 3. 如果不存在，则选中默认首页，并把url里的参数去掉。
		},
		requestInitialData() {
			// request:
			// 1. category
			// console.log("requestInitialData");
			// 1. mark as loading
			const that = this;
			that.loading = true;

			const url = "/api/gatewayCms/articles/category";
			axios
				.get(url, { params: { mold_types: "2" } })
				.then((response) => {
					// that.loading = false;
					// console.log(response);
					const responseData = response.data.data;
					// setup category
					that.setupCategoryTabs(responseData);
					that.loading = false;
					that.loadingError = {};
				})
				.catch((error) => {
					that.loading = false;
					that.loadingError = error;
					// console.log(error);
				});

			// 1. request
			// 2. setup data
			// 3. data drives ui
		},
		handleSearch() {
			if (this.searchTerm?.trim().length > 0) {
				var query = { keywords: this.searchTerm?.trim() };
				this.$router.push({ path: "/vlog/search", query });
			}
		},
	},
	mounted() {
		// console.log(this.$route.params);

		this.updateMeta();
		// 1. request category data
		// 2. setup list components，keep alive and conditioning rendering
		this.urlTabID = this.$route.params?.tabid?.trim();
		// console.log(this.$route.params);
		this.requestInitialData();
	},
};
</script>
<style scoped>
.vlog-home {
	padding: 0 16px;
}
</style>
